import { computed, ref, useSlots, useCssModule } from "vue";
import XCard from "./XCard.js";
import { u as useIconProps, X as XIcon } from "./assets/XIcon-U9bwokTN.js";
import { u as useBreakpoints } from "./assets/index-CUpSEhYe.js";
import "./assets/index-CgZzOVq6.js";
import { u as useListeners } from "./assets/index-Ca8wHgNc.js";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import { u as useElevationProp } from "./assets/index-hC42R8vZ.js";
import { u as useLinkProps } from "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-vzP2cezV.js";
import "vue-demi";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "@fortawesome/vue-fontawesome";
import "./tokens.js";
function useAnimateIcons(props) {
  const canAnimateIcons = computed(() => props.icon && props.hoverIcon);
  const isHovering = ref(false);
  const baseIconStyles = computed(() => ({
    opacity: isHovering.value ? 0 : 1
  }));
  const hoverIconStyles = computed(() => ({
    opacity: isHovering.value ? 1 : 0
  }));
  function handleHover(event) {
    isHovering.value = event.type === "mouseover" && canAnimateIcons.value;
  }
  return {
    baseIconStyles,
    hoverIconStyles,
    canAnimateIcons,
    handleHover
  };
}
const XCardInteractive$1 = "_XCardInteractive_1xls4_1";
const isDisabled = "_isDisabled_1xls4_4";
const iconContainer = "_iconContainer_1xls4_23";
const baseIcon = "_baseIcon_1xls4_30";
const hoverIcon = "_hoverIcon_1xls4_31";
const content = "_content_1xls4_44";
const title = "_title_1xls4_50";
const description = "_description_1xls4_59";
const ctaContainer = "_ctaContainer_1xls4_67";
const ctaText = "_ctaText_1xls4_75";
const ctaIcon = "_ctaIcon_1xls4_82";
const hasAnimation = "_hasAnimation_1xls4_130";
const style0 = {
  XCardInteractive: XCardInteractive$1,
  isDisabled,
  iconContainer,
  baseIcon,
  hoverIcon,
  content,
  title,
  description,
  ctaContainer,
  ctaText,
  ctaIcon,
  hasAnimation
};
const { createIconProps } = useIconProps();
const { icon: hoverIconProp, iconStyle: hoverIconStyleProp } = createIconProps();
const { createElevationProp } = useElevationProp();
const { createLinkProps, getLinkProps } = useLinkProps();
const { createDisabledProp, getDisabledClass } = useDisabledProp();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const SIZE_OPTIONS = ["regular", "medium", "large"];
const PADDING_VARIABLES = {
  regular: "var(--space-regular)",
  medium: "var(--space-medium)",
  large: "var(--space-large)"
};
const ICON_SIZE_VARIABLES = {
  regular: "2x",
  medium: "2xl",
  large: "2xl"
};
const TYPE_TAGS = {
  button: "button",
  link: "a"
};
const __default__ = {
  name: "XCardInteractive",
  components: { XCard, XIcon }
};
const _sfc_main = Object.assign(__default__, {
  props: {
    type: {
      type: String,
      default: "button",
      validation: (type) => ["button", "link"].includes(type)
    },
    title: {
      type: String,
      default: ""
    },
    ctaText: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "regular",
      validation: (size) => SIZE_OPTIONS.includes(size)
    },
    width: {
      type: String,
      default: ""
    },
    hoverIcon: hoverIconProp,
    hoverIconStyle: hoverIconStyleProp,
    ...createIconProps(),
    ...createElevationProp(),
    ...createDisabledProp(),
    ...createLinkProps(),
    ...createTestIdProp()
  },
  emits: ["click"],
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const { v2Listeners } = useListeners(["click", "mouseover", "mouseleave"]);
    const { isMobile } = useBreakpoints();
    const { baseIconStyles, hoverIconStyles, canAnimateIcons, handleHover } = useAnimateIcons(props);
    const $style = useCssModule();
    const { formatTestId } = setupTestId(props);
    const { disabledClass } = getDisabledClass(props);
    const iconSize = computed(() => ICON_SIZE_VARIABLES[props.size]);
    const cardStyles = computed(() => ({
      width: isMobile.value ? "100%" : props.width
    }));
    const cardArgs = computed(() => ({
      tag: TYPE_TAGS[props.type],
      elevation: props.elevation,
      padding: PADDING_VARIABLES[props.size],
      borderRadius: "var(--border-radius-large)",
      dataTestid: props.dataTestid,
      disabled: props.disabled,
      style: cardStyles.value,
      ...getLinkProps(props)
    }));
    const cardClasses = computed(() => ({
      [$style.hasAnimation]: canAnimateIcons.value,
      ...disabledClass.value
    }));
    const baseIconProps = computed(() => ({
      icon: props.icon,
      "icon-style": props.iconStyle,
      size: iconSize.value
    }));
    const hoverIconProps = computed(() => ({
      icon: props.hoverIcon,
      "icon-style": props.hoverIconStyle,
      size: iconSize.value
    }));
    return { __sfc: true, createIconProps, hoverIconProp, hoverIconStyleProp, createElevationProp, createLinkProps, getLinkProps, createDisabledProp, getDisabledClass, createTestIdProp, setupTestId, SIZE_OPTIONS, PADDING_VARIABLES, ICON_SIZE_VARIABLES, TYPE_TAGS, slots, props, v2Listeners, isMobile, baseIconStyles, hoverIconStyles, canAnimateIcons, handleHover, $style, formatTestId, disabledClass, iconSize, cardStyles, cardArgs, cardClasses, baseIconProps, hoverIconProps, XCard, XIcon };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.XCard, _vm._g(_vm._b({ class: [_setup.$style.XCardInteractive, _setup.cardClasses], on: { "mouseover": _setup.handleHover, "mouseleave": _setup.handleHover, "click": function($event) {
    return _vm.$emit("click", $event);
  } } }, "XCard", _setup.cardArgs, false), _setup.v2Listeners), [_vm.icon ? _c("div", { class: _setup.$style.iconContainer, attrs: { "data-testid": _setup.formatTestId("iconContainer") } }, [_c(_setup.XIcon, _vm._b({ class: _setup.$style.baseIcon, style: _setup.baseIconStyles, attrs: { "data-testid": _setup.formatTestId("baseIcon") } }, "XIcon", _setup.baseIconProps, false)), _vm.hoverIcon ? _c(_setup.XIcon, _vm._b({ class: _setup.$style.hoverIcon, style: _setup.hoverIconStyles, attrs: { "data-testid": _setup.formatTestId("hoverIcon") } }, "XIcon", _setup.hoverIconProps, false)) : _vm._e()], 1) : _vm._e(), _c("div", { class: _setup.$style.content }, [_vm.title ? _c("h5", { class: _setup.$style.title, attrs: { "data-testid": _setup.formatTestId("title") } }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _setup.slots.default ? _c("div", { class: _setup.$style.description, attrs: { "data-testid": _setup.formatTestId("description") } }, [_vm._t("default")], 2) : _vm._e(), _vm.ctaText ? _c("div", { class: _setup.$style.ctaContainer }, [_c("span", { class: _setup.$style.ctaText, attrs: { "data-testid": _setup.formatTestId("ctaText") } }, [_vm._v(" " + _vm._s(_vm.ctaText) + " ")]), _c(_setup.XIcon, { class: _setup.$style.ctaIcon, attrs: { "right": "", "icon": "arrow-right", "size": "sm" } })], 1) : _vm._e()])]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XCardInteractive = __component__.exports;
export {
  ICON_SIZE_VARIABLES,
  PADDING_VARIABLES,
  SIZE_OPTIONS,
  TYPE_TAGS,
  XCardInteractive as default
};
